<div class="register-page">
  <div class="page-bg"></div>
  <div class="page-scrim"></div>
  <div class="orb orb--one"></div>
  <div class="orb orb--two"></div>
  <div class="orb orb--three"></div>
  <div class="grid-overlay"></div>

  <div class="register-content">
    @if (successMessage()) {
      <div class="glass-card glass-card--success">
        <div class="success-icon">
          <span class="material-icons">check</span>
        </div>
        <h1>Registration received</h1>
        <p>{{ successMessage() }}</p>
        <a routerLink="/login" class="submit-btn">
          <span>Back to login</span>
          <span class="material-icons">arrow_forward</span>
        </a>
      </div>
    } @else {
      <form class="glass-card" (ngSubmit)="submit()" #registerForm="ngForm">
        <div class="glass-card__header">
          <div class="brand">
            <div class="logo-mark">
              <img src="/itrace-logo.jpeg" alt="iTrace" />
            </div>
            <span class="brand-name">iTrace</span>
          </div>
          <h1>Register your company</h1>
          <p>Create a company account to start exchanging data on the network</p>
        </div>

        <div class="section-label">
          <span class="material-icons">apartment</span>
          Company details
        </div>

        <div class="form-grid">
          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">business</span>
              <input name="name" [(ngModel)]="form.name" required maxlength="200" placeholder=" " id="name" />
              <label for="name">Company name</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">badge</span>
              <input
                name="registrationNo"
                [(ngModel)]="form.registrationNo"
                required
                maxlength="100"
                placeholder=" "
                id="registrationNo"
              />
              <label for="registrationNo">Registration number</label>
            </div>
          </div>

          <div class="field">
            <app-country-select
              name="countryCode"
              [(ngModel)]="form.countryCode"
              required
              variant="glass"
              icon="public"
              label="Country"
            />
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">mail_outline</span>
              <input
                type="email"
                name="contactEmail"
                [ngModel]="form.contactEmail"
                (ngModelChange)="onContactEmailChange($event)"
                required
                maxlength="255"
                placeholder=" "
                id="contactEmail"
              />
              <label for="contactEmail">Contact email</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">call</span>
              <input
                name="contactPhone"
                [(ngModel)]="form.contactPhone"
                maxlength="50"
                placeholder=" "
                id="contactPhone"
              />
              <label for="contactPhone">Contact phone (optional)</label>
            </div>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">place</span>
              <input name="address" [(ngModel)]="form.address" maxlength="500" placeholder=" " id="address" />
              <label for="address">Address (optional)</label>
            </div>
          </div>
        </div>

        <div class="section-label">
          <span class="material-icons">badge</span>
          Admin account
        </div>

        <div class="form-grid">
          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">person_outline</span>
              <input
                name="adminFullName"
                [(ngModel)]="form.admin.fullName"
                required
                maxlength="200"
                placeholder=" "
                id="adminFullName"
              />
              <label for="adminFullName">Admin full name</label>
            </div>
          </div>

          <div class="field-group">
            <div class="field" [class.field--error]="adminEmailError()">
              <div class="field__control">
                <span class="material-icons field__icon">alternate_email</span>
                <input
                  type="email"
                  name="adminEmail"
                  [ngModel]="form.admin.email"
                  (ngModelChange)="onAdminEmailChange($event)"
                  [disabled]="sameAsContactEmail()"
                  required
                  maxlength="255"
                  placeholder=" "
                  id="adminEmail"
                />
                <label for="adminEmail">Admin email</label>
              </div>
              @if (adminEmailError()) {
                <p class="field__error">{{ adminEmailError() }}</p>
              }
            </div>
            <label class="checkbox-row">
              <input
                type="checkbox"
                name="sameAsContactEmail"
                [ngModel]="sameAsContactEmail()"
                (ngModelChange)="toggleSameAsContactEmail($event)"
              />
              <span>Same as contact email</span>
            </label>
          </div>

          <div class="field">
            <div class="field__control">
              <span class="material-icons field__icon">lock_outline</span>
              <input
                [type]="showPassword() ? 'text' : 'password'"
                name="adminPassword"
                [(ngModel)]="form.admin.password"
                required
                minlength="8"
                placeholder=" "
                id="adminPassword"
              />
              <label for="adminPassword">Password (8+ chars)</label>
              <button
                type="button"
                class="field__toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              >
                <span class="material-icons">{{ showPassword() ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>
        </div>

        @if (errorMessage()) {
          <p class="error">
            <span class="material-icons">error_outline</span>
            {{ errorMessage() }}
          </p>
        }

        <button type="submit" class="submit-btn" [disabled]="registerForm.invalid || isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner"></span>
            <span>Registering...</span>
          } @else {
            <span>Register company</span>
            <span class="material-icons">arrow_forward</span>
          }
        </button>

        <div class="glass-card__footer">
          <span>Already have an account?</span>
          <a routerLink="/login">Back to login</a>
        </div>
      </form>
    }
  </div>
</div>
